<template>
  <label
    class="cursor-pointer rounded-3xl border-2 bg-light-gray-200 p-3 transition-colors duration-300 lg:p-5"
    :class="modelValue === valueBy ? 'border-blue-950' : ''"
  >
    <input v-model="selected" class="sr-only" type="radio" :value="valueBy" v-bind="$attrs" />
    <div
      class="mr-3 h-5 w-5 rounded-full border-blue-950 bg-transparent lg:mb-3"
      :class="modelValue === valueBy ? 'border-[6px]' : 'border-2'"
    ></div>
    <span class="block text-base font-medium text-blue-950 lg:block lg:text-lg">{{ title }}</span>
    <span v-if="description" class="mt-[6px] inline-block text-sm text-neutral-500 lg:mt-1">{{
      description
    }}</span>
  </label>
</template>

<script setup lang="ts">
const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  modelValue: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  valueBy: {
    type: String,
    required: false
  },
  description: {
    type: String,
    required: false
  }
})

const selected = computed({
  get: () => props.modelValue,
  set: (value: string) => emit('update:modelValue', value)
})
</script>
